import {
  findAllSearchAlerts
} from "./chunk-ZMHFAQNV.js";
import {
  getConfigWithMetadata,
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/findAllSearchAlerts/findAllSearchAlerts.ts
async function findAllSearchAlerts2(params, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "findAllSearchAlerts");
    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
      );
    }
    const response = await findAllSearchAlerts(params, _apiConfig);
    return { status: "success", data: response };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  findAllSearchAlerts2 as findAllSearchAlerts
};
